import React from 'react';
import clsx from 'clsx';

const SideLayout = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={clsx(
        'w-full sm:w-[90%] md:w-[424px]',
        'max-w-[424px]',
        'mx-auto md:mx-0',
        'flex flex-col gap-6',
        'animate-fadeIn',
        className
      )}
    >
      <div className="w-full bg-white rounded-xl px-2 md:px-6">{children}</div>
    </div>
  );
};

export default SideLayout;
